// The mark the pages show: the Focus hero, the boot frame, the picker.
//
// 228 px square, three times the 76 px hero so it stays sharp on a phone, in a
// 256-colour palette: 25 KB, where the 512 px original in `public/` is 239 KB.
// The boot frame in `index.html` loads it on every cold load, before React, so
// its size is paid on every surface, not only on Focus.
//
// Imported, so the build hashes it into `/assets/`, which nginx serves with a
// year's immutable cache. `index.html`'s static boot frame names the same file
// (`/src/ui/logo.png`); the build rewrites that to the same hashed URL. The
// 512 px original is `public/logo.png`: the home-screen icon
// (`apple-touch-icon`) and the Gmail add-on's logo. `public/loom-logo.png` is
// the same bytes, kept for the add-on deployments that still point at it.

import logo from "./logo.png";

export const LOGO_SRC: string = logo;
